import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress } from '@mui/material';

import { LinkProps } from 'react-router-dom';

interface ButtonProps extends Omit<MuiButtonProps, 'variant' | 'size'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  component?: React.ElementType;
  to?: string;
  state?: any;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', isLoading, children, disabled, component, to, state, ...props }, ref) => {

    let muiVariant: MuiButtonProps['variant'] = 'contained';
    let muiColor: MuiButtonProps['color'] = 'primary';

    if (variant === 'secondary') {
      muiVariant = 'contained';
      muiColor = 'secondary';
    } else if (variant === 'outline') {
      muiVariant = 'outlined';
      muiColor = 'inherit';
    } else if (variant === 'ghost') {
      muiVariant = 'text';
      muiColor = 'inherit';
    }

    let muiSize: MuiButtonProps['size'] = 'medium';
    if (size === 'sm') muiSize = 'small';
    if (size === 'lg') muiSize = 'large';

    return (
      <MuiButton
        ref={ref}
        variant={muiVariant}
        color={muiColor}
        size={muiSize}
        disabled={isLoading || disabled}
        className={className}
        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
        sx={{
          textTransform: 'none',
          boxShadow: variant === 'ghost' || variant === 'outline' ? 'none' : undefined,
          ...props.sx
        }}
        component={component as any}
        to={to}
        state={state}
        {...props}
      >
        {children}
      </MuiButton>
    );
  }
);
Button.displayName = 'Button';
